import {
  FormControl,
  InputAdornment,
  MenuItem,
  Paper,
  Select,
  styled,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Controller, UseFormReturn } from "react-hook-form";
import { personalDetailsFields, groupingFamilyOptions } from "../fieldData";
import { calculateAge } from "../../../../utilis/methods/dateMethods";
import { CustomFormField } from "../../../../utilis/component/CustomFormElement";
import { getLanguage, getMaritalStatus, getRace } from "../registrationServices";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
// import { generateQatarIdPrefix } from "./idPrefix";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import usePopup from "../../../../hooks/usePopup";
import FileUploadModal from "./FileUploadModal";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
interface PersonalDetailsProps {
  formControls: UseFormReturn<any>;
}

const StyledTextField = styled("div")(({ }) => ({
  "& .MuiTextField-root": {
    "& .MuiOutlinedInput-root": {
      borderTopLeftRadius: 5,
      borderBottomLeftRadius: 5,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
  },
  // },
}));

const StyledSelect = styled("div")(({ }) => ({
  "& .MuiFormControl-root": {
    "& .MuiOutlinedInput-root": {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderTopRightRadius: 5,
      borderBottomRightRadius: 5,
      borderLeft: 0,
      // "& fieldset": {
      //   borderLeftWidth: 0,
      // },
    },
  },
  // },
}));

const QATAR_ID_MAX_LENGTH = 11;

const PersonalDetails: React.FC<PersonalDetailsProps> = ({ formControls }) => {
  const { patientid } = useParams();
  const [idType, setIdType] = useState<string>("Qatar");
  const [ageType, setAgeType] = useState<"D" | "M" | "Y">("Y");
  const { control, setValue, watch, clearErrors} = formControls;
  const [openUpload, setOpenUpload] = useState(false);
  const { CustomModal } = usePopup();

  const {
    data: maritalStatus,
    isLoading: maritalStatusLoading,
  } = useQuery(["getMaritalStatus"], getMaritalStatus, {
    refetchOnWindowFocus: false,
  });

  const {
    data: languages,
    isLoading: languagesLoading,
  } = useQuery(["getLanguage"], getLanguage, {
    refetchOnWindowFocus: false,
  });

  const {
    data: race,
    isLoading: raceLoading,
  } = useQuery(["getRace"], getRace, {
    refetchOnWindowFocus: false,
  });

  const onChange = (e: any) => {
    const { value, name } = e.target;
    if (name === "id" && idType === "Qatar") {
      const numeric = value.replace(/\D/g, "").slice(0, QATAR_ID_MAX_LENGTH);
      setValue("id", numeric, { shouldValidate: true });
    }
  };

  const dobChanges = watch("dob");
  const idTypeChange = watch("idType");


  if (dobChanges) {
    console.log("Nationality exists:", dobChanges);
  } else {
    console.log("Nationality is missing");
  }

 useEffect(() => {
  // if (dobChanges) {
  //   if (patientid) setValue("id", "");
  //   return;
  // }
  const { age, ageType: calculatedType } = calculateAge(dobChanges);
  setAgeType(calculatedType);
  setValue("age", age);
  clearErrors("age");

  /*
  if (idTypeChange === "Qatar") {
    const newPrefix = generateQatarIdPrefix(dobChanges); 
    const currentId = watch("id") || "";
    if (!currentId.startsWith(newPrefix)) {
      const prefixLength = newPrefix.length;
      const suffix = currentId.length > prefixLength ? currentId.slice(prefixLength) : "";
      
      setValue("id", `${newPrefix}${suffix}`, { shouldValidate: true });
    }
  }
  */

  setIdType(idTypeChange);

}, [dobChanges, idTypeChange, patientid, setValue, watch, clearErrors]);


  useEffect(() => {
    if (dobChanges) {
      const { age, ageType } = calculateAge(dobChanges);
      setAgeType(ageType);
      setValue(personalDetailsFields.age.name, age);
      clearErrors(personalDetailsFields.age.name)
      /*
      if (idTypeChange == "Qatar") {
      } else {
        (!Boolean(patientid) && setValue(personalDetailsFields.id.name, ""));
      }
      */
    } else {
      // idTypeChange == "Qatar" ? setValue(personalDetailsFields.id.name, "") : setValue(personalDetailsFields.id.name, "")
    }
    setIdType(idTypeChange);
  }, [dobChanges, idTypeChange]);



  return (
    <div>
      <CustomModal
        open={openUpload}
        setOpen={setOpenUpload}
        title="Upload Documents"
      >
        <FileUploadModal
          formControls={formControls}
          onClose={() => setOpenUpload(false)}
        />
      </CustomModal>
      <div className="relative top-4 left-3 bg-blue-600 w-fit px-1 rounded text-white flex items-center gap-1">
        <Typography
          gutterBottom
          component="div"
          fontSize={15}
          color={"inherit"}
          sx={{ mb: 0 }}
        >
          Patient details
        </Typography>
          <Tooltip title="Upload Documents">
            <IconButton
              size="small"
              color="inherit"
              onClick={() => setOpenUpload(true)}
              sx={{ p: 0.5 }}
            >
              <CloudUploadIcon fontSize="small" />
            </IconButton>
          </Tooltip>
      </div>
      <Paper elevation={4} className="pt-3 h-full">
        <div className="p-3 grid grid-cols-2 gap-3">
          <CustomFormField
            control={control}
            {...personalDetailsFields.firstName}
          />
          <CustomFormField
            control={control}
            {...personalDetailsFields.middleName}
          />
          <CustomFormField
            control={control}
            {...personalDetailsFields.lastName}
          />
          <div className="grid grid-cols-5 gap-2 place-content-center">
            <div className="col-span-3">
              <CustomFormField
                control={control}
                {...personalDetailsFields.dob}
                rules={{ ...personalDetailsFields.dob.rules }}
              />
            </div>
            <div className="col-span-2">
              <CustomFormField
                control={control}
                {...personalDetailsFields.age}
                rules={{ ...personalDetailsFields.age.rules, maxLength: { value: 3, message: "Invalid age" } }}
                fieldProps={{
                  ...personalDetailsFields.age.fieldProps,
                  inputProps: { maxLength: 3 },
                  InputProps: {
                    endAdornment: (
                      <InputAdornment position="start">
                        {ageType}
                      </InputAdornment>
                    ),
                  },
                }}
              />
            </div>
          </div>

          <div className="flex">
            <StyledTextField className="flex w-full">
              <CustomFormField
                control={control}
                {...personalDetailsFields.id}
                fieldProps={{
                  label: `${idType} ID`,
                  inputProps: {
                    maxLength: idType === "Qatar" ? QATAR_ID_MAX_LENGTH : undefined,
                  },
                }}
                rules={{
                  required: `${idType} ID required`,

                  validate: (value: string) => {
                    if (idType === "Qatar") {
                      if (!/^\d+$/.test(value))
                        return "Qatar ID must contain only numbers";

                      if (value.length !== QATAR_ID_MAX_LENGTH)
                        return `Qatar ID must be exactly ${QATAR_ID_MAX_LENGTH} digits`;
                    }

                    return true;
                  },

                  onChange,
                }}
              />
            </StyledTextField>
            <StyledSelect className="flex">
              <Controller
                defaultValue={idType}
                control={control}
                name="idType"
                render={({ field: { onChange, ...field } }) => (
                  <FormControl sx={{ width: 35 }} size="small">
                    <Select
                      {...field}
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      value={""}
                      onChange={(e) => {
                        onChange(e.target.value);
                        setIdType(e.target.value);
                        setValue("id", "");
                         clearErrors("id"); 
                      }}
                    >
                      <MenuItem selected value={"Qatar"}>
                        QatarId
                      </MenuItem>
                      <MenuItem value={"Passport"}>Passport</MenuItem>
                      <MenuItem value={"GCC"}>GCC</MenuItem>
                    </Select>
                  </FormControl>
                )}
              />
            </StyledSelect>
          </div>

          <CustomFormField
            control={control}
            {...personalDetailsFields.maritalStatus}
            options={maritalStatus?.response || []}
            autocompleteProps={{
              ...personalDetailsFields.maritalStatus.autocompleteProps,
              loading: maritalStatusLoading,
            }}
          />
          <CustomFormField
            control={control}
            {...personalDetailsFields.gender}
          />
          <CustomFormField
            control={control}
            {...personalDetailsFields.isVip}
            radioProps={{ ...personalDetailsFields.isVip.radioProps }}
            fieldProps={{ ...personalDetailsFields.isVip.fieldProps }}
          />
          <CustomFormField
            control={control}
            {...personalDetailsFields.language}
            options={languages?.response || []}
            loading={languagesLoading}
            fieldProps={{
              ...personalDetailsFields.language.fieldProps,
            }}
          />
          <CustomFormField
            control={control}
            {...personalDetailsFields.groupingFamily}
            options={groupingFamilyOptions}
          />
          <div className="hidden">

            <CustomFormField
              control={control}
              {...personalDetailsFields.race}
              options={race?.response || []}
              loading={raceLoading}
              fieldProps={{
                ...personalDetailsFields.race.fieldProps,
              }}
            />
          </div>

        </div>
      </Paper>
    </div>
  );
};

export default PersonalDetails;
